<template>
  <div class="company-specific-info-card">
    <tabs :tabs="tabs" :active-tab="activeTab" :tabs-styling="tabsStyling" :tabs-labels-styling="tabsLabelsStyling"
      :center-tabs="false" @startTabChange="activeTab = $event" />
    <div v-if="tabs[activeTab].id === 'users'" :style="{ 'height': 'calc(100% - 60px)', 'margin-top': '21px' }">
      <Table :checkbox="false" :removeTableLines="true" :loading="loading" :headers="usersHeaders" :items="users" :add-row-button="false"
        :action-buttons="false" />
    </div>
    <div v-if="tabs[activeTab].id === 'company'" :style="{ 'height': 'calc(100% - 60px)', 'margin-top': '21px' }">
      <SingleEditObjectMainInfoCompanies :specialDisable="specialDisable" @update-company="updateCompany($event)" :data="role.company"
        :editableLabel="'Company *'" :editableInputOptions="allCompanies.data" :editingData="editingData" />
    </div>
    <div v-if="editingData" class="action-buttons">
      <custom-button :label="$t('Cancel')" :button-color="'#FFF'" :label-color="'var(--app-primary-base)'"
        :button-styling="actionButtonsStyling" @buttonClick="$emit('cancel-edit')" />
      <custom-button :label="$t('Save')" :button-color="'var(--app-primary-base)'" :label-color="'#FFF'"
        :button-styling="actionButtonsStylingSave" :disabled="!requiredFieldsFilled"
        @buttonClick="$emit('save-material')" />
    </div>
  </div>
</template>

<script>
import Tabs from '@/newComponents/_Atoms/Tabs.vue';
import Table from '@/newComponents/_Molecules/Table';
import SingleEditObjectMainInfoCompanies from '../../_Organisms/SingleEditObjectMainInfoCompanies.vue';
import { mapActions } from "vuex";
import CustomButton from '@/newComponents/_Atoms/CustomButton.vue';

export default {
  name: "RoleSpecificInfo",

  components: {
    Tabs,
    Table,
    SingleEditObjectMainInfoCompanies,
    CustomButton,
  },

  props: {
    users: {
      type: Array,
      required: true,
    },

    specialDisable: {
      type: Boolean,
    },

    roles: {
      type: Array,
      required: true,
    },

    workspaces: {
      type: Array,
      required: true,
    },

    requiredFieldsFilled: {
      type: Boolean,
      required: true,
    },

    role: {
      type: Object,
      required: true
    },

    editingData: {
      type: Boolean
    },
  },

  data() {
    return {
      activeTab: 0,
      tabsStyling: {
        'margin': '0px 0px 8px 0px',
        'width': '100%',
        'height': '39px',
      },
      tabsLabelsStyling: {
        'text-transform': 'none',
        'font-size': '10px',
        'letter-spacing': '0',
      },
      actionButtonsStyling: {
        'border': '1px solid var(--app-primary-base)',
        'border-radius': '7px',
        'font-size': '10px',
        'line-height': '12px',
        'height': '20px',
        'font-weight': '600'
      },
      actionButtonsStylingSave: {
        'font-size': '10px',
        'line-height': '12px',
        'height': '20px',
        'font-weight': '600'
      },
      loading: false,
      allCompanies: [],
      editingData: false
    }
  },

  mounted() {
    this.getAllCompanies();
  },

  watch: {
    editingData(value) {
      if(value) {
        this.activeTab = 0
      }
    }
  },

  computed: {
    usersHeaders() {
      return [
        {
          text: this.$i18n.t('Name'),
          varName: "first_name",
          editable: false,
        },
        {
          text: this.$i18n.t('Username'),
          varName: "username",
          editable: false,
        },
        {
          text: this.$i18n.t('Email'),
          varName: "email",
          editable: false,
        },
      ]
    },

    tabs() {
      if (this.editingData) {
        return [
          {
            id: 'company',
            label: this.$i18n.tc("Company", 1),
          },
        ]
      } else {
        return [
          {
            id: 'users',
            label: this.$i18n.tc("Users", 2),
          },
          {
            id: 'company',
            label: this.$i18n.tc("Company", 1),
          },
        ]
      }
    },
  },

  methods: {
    ...mapActions(["fetchAllCompanies"]),

    updateCompany(event) {
      this.role.company = event
    },

    async getAllCompanies() {
      try {
        const response = await this.fetchAllCompanies({ paginate: false });
        if (response.data && response.data.length > 0) {
          this.allCompanies = {
            ...response,
            data: response.data.map(company => ({
              ...company,
              code: company.id
            }))
          };
        } else {
          this.allCompanies = response;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>

<style scoped>
.company-specific-info-card {
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  padding: 17px 21px;
  flex: 1;
  position: relative;
  height: auto;
}

.action-buttons {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-end;
  position: absolute;
  right: 21px;
  bottom: 17px;
}
</style>


// WEBPACK FOOTER //
// src/newComponents/SystemManagement/Roles/RoleSpecificInfo.vue